function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import queryString from 'query-string';
const parseArrayRequest = request => request.split(',');
export const parseQueryString = values => {
  const filter = {
    category: values.category ? values.category.split(',') : [],
    company: values.company ? values.company.split(',') : [],
    srri: values.srri ? parseArrayRequest(values.srri) : [],
    country: values.country ? parseArrayRequest(values.country) : [],
    order: values.order ? values.order : '-totalNetAsset'
  };
  if (values.page) filter.page = values.page;
  return filter;
};
export const parseQueryStringFromString = search => {
  const values = queryString.parse(search);
  return parseQueryString(values);
};
export const setPropertyToFilter = (filter, property, value) => {
  const newFilter = _objectSpread({}, filter);
  newFilter[property] = value;
  return newFilter;
};
export const getQueryStringFromFilters = filters => {
  const paths = [];
  paths.push(filters.category.length ? `category=${filters.category.join(',')}` : null);
  paths.push(filters.company.length ? `company=${filters.company.join(',')}` : null);
  paths.push(filters.srri.length ? `srri=${filters.srri.join(',')}` : null);
  paths.push(filters.country.length ? `country=${filters.country.join(',')}` : null);
  paths.push(filters.order ? `order=${filters.order}` : null);
  paths.push(filters.page ? `page=${filters.page}` : null);
  return paths.filter(param => Boolean(param)).join('&');
};